
<template>
  <div class="about-nav">
    <ul>
      <li><router-link to="/synopsis">拍界简介</router-link></li>
      <li><router-link to="/culture">企业文化</router-link></li>
      <li><router-link to="/service">服务内容</router-link></li>
      <li><router-link to="/honor">企业荣誉</router-link></li>
      <li><router-link to="/development">发展历程</router-link></li>
      <li><router-link to="/contact">联系我们</router-link></li>
      <li><router-link to="/partner">招募合伙人</router-link></li>
      <li><router-link to="/paimaigonggao">拍卖资讯</router-link></li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'AboutUsNav',
  data() {
    return{}
  },
  created() {
    
  }
}
</script>
<style scoped>
.about-nav {
  display: none;
}
@media screen and (max-width: 540px){
  .about-nav {
    display: block;
    overflow-x: scroll;
    width: 100%;
    text-align: left;
  }
  .about-nav ul {
		display: flex;
		flex-wrap: nowrap;
		width: max-content;
  }
  .about-nav ul li{
		font-size: 0.7rem;
    line-height: 2rem;
    padding: 0 10px;
		background-color: blanchedalmond;
  }
  .router-link-active {
    color:#c71622;
  }
}
</style>